import { render } from "./RegisterAsParticipant.vue?vue&type=template&id=60fb05e8&scoped=true"
import script from "./RegisterAsParticipant.vue?vue&type=script&lang=js"
export * from "./RegisterAsParticipant.vue?vue&type=script&lang=js"

import "./RegisterAsParticipant.vue?vue&type=style&index=0&id=60fb05e8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fb05e8"]])

export default __exports__